import { RiLayoutColumnLine, RiPencilLine } from '@remixicon/react';
import { type ReactNode, useCallback } from 'react';
import type { BreadcrumbType } from 'src/components/atoms/Breadcrumbs';
import { PageHeader, PageType } from 'src/components/containers/PageHeader';
import { AgButton } from 'src/components/ui';
import { useWarehousePage } from './WarehousePageProviders';

/** Shown only once the warehouse is loaded; until then the content section carries the skeleton or retry. */
export function WarehousePageHeader({ metadata }: { metadata: (warehouseName: string) => ReactNode }) {
  const { sections, setEditModalOpen, setGroupingsModalOpen } = useWarehousePage();
  const { warehouse } = sections;
  const warehouseName = warehouse?.place.description || (warehouse ? `Warehouse ${warehouse.id}` : '');

  const getBreadcrumbs = useCallback(
    (): BreadcrumbType[] => [
      { title: 'Settings', path: '/settings' },
      { title: 'Inventory', path: '/settings/inventory' },
      { title: 'Warehouses', path: '/settings/inventory?tab=warehouses' },
      { title: warehouseName },
    ],
    [warehouseName]
  );

  if (!warehouse) return null;

  return (
    <>
      {metadata(warehouseName)}
      <PageHeader
        pageType={PageType.WarehouseDetails}
        title={warehouseName}
        entitySlug={String(warehouse.id)}
        getBreadcrumbs={getBreadcrumbs}
      >
        <div className="flex grow" />
        <AgButton variant="white" onPress={() => setEditModalOpen(true)}>
          <RiPencilLine size={20} />
          Warehouse Details
        </AgButton>
        <AgButton variant="white" onPress={() => setGroupingsModalOpen(true)}>
          <RiLayoutColumnLine size={20} />
          Location Groupings
        </AgButton>
      </PageHeader>
    </>
  );
}
